import { Box, Grid } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import {
  Calendar,
  Event,
  EventProps,
  momentLocalizer,
} from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import ToolBarAvailability from "../../../../../components/app/provider/scheduling/ToolBarAvailability";
import useDisclosure from "../../../../../hooks/use-disclosure";
import { ToolBarPropsType } from "../SchedulingLayout";

import moment from "moment";
import "moment-timezone";
import "./index.css";

import { getStoredRealm } from "@/utils/auth-storage";
import dayjs from "dayjs";
import { useFormik } from "formik";
import Flex from "../../../../../components/Flex";
import LoadingOverlay from "../../../../../components/LoadingOverlay";
import Text from "../../../../../components/Text";
import { useSlotList } from "../../../../../queries/use-get-slots";
import { getStartEndDateOfSameDay } from "../../../../../utils/date-time-utility";
import SlotAvailabilityModal from "./SlotAvailabilityModal";
import { CALENDER_STYLE, EventType, groupByDay } from "./availability-contant";
const localizer = momentLocalizer(moment);

const Availability = () => {
  const user = sessionStorage.getItem("user");
  const userData = user ? JSON.parse(user) : null;

  //initial filters
  const initialFilters = {
    locations: undefined,
    providers: {
      value: userData?.uuid,
      label: userData?.firstName + " " + userData?.lastName,
    },
    type: undefined,
    mode: "VIRTUAL",
  };

  const formik = useFormik<any>({
    initialValues: initialFilters,
    onSubmit: () => {},
  });

  const PAGINATION = { page: 0, pageSize: 500 };

  const { data: activeSlots, isLoading } = useSlotList({
    pagination: PAGINATION,
    providerUuid: formik.values.providers?.value,
    locationUuid: formik.values.locations?.value,
    appointmentType: formik.values?.type?.value as any,
    availabilityMode: formik.values?.mode,
    xTENANTID: getStoredRealm() ?? "",
  });

  const EVENT: EventType[] | undefined = activeSlots?.data?.content?.map(
    (it: any) => {
      return {
        start: new Date(it.startTime),
        end: new Date(it.endTime),
        ...it,
      };
    }
  );

  const toolBarComponent = useCallback(
    (props: ToolBarPropsType) => {
      return <ToolBarAvailability {...props} formik={formik} />;
    },
    [formik]
  );

  const combinedEvents: Event[] | undefined = Object.entries(
    groupByDay(EVENT) ?? {}
  )?.map((it: any) => ({
    title: it[1]?.length + " Slots Available",
    startTime: undefined,
    endTime: undefined,
    start: it[0] as any,
    end: getStartEndDateOfSameDay(dayjs(it[0]))?.endTime as any,
    allSlots: it?.[1] ?? [],
  }));

  function eventWrapper(props: EventProps) {
    return (
      <Flex
        height={"100%"}
        width={"100%"}
        bgcolor={"#F3F4F6"}
        id="event-wrap"
        alignItems={"center"}
        justifyContent={"center"}
      >
        {/* <Box minWidth={"4px"} borderRadius={10} bgcolor={"Red"} /> */}

        <Flex gap={1} ml={1} flexDirection={"column"}>
          <Text>{props.title}</Text>
          {/* <Flex gap={1}> */}
          {/* <Text c={"primary"}>{props.event.title}</Text> */}
          {/* <Text color={"#1A1A1A99"}>{`(${appointmentType})`}</Text> */}
          {/* </Flex> */}
        </Flex>
      </Flex>
    );
  }

  const eventPropGetter = () => {
    return {
      style: {
        backgroundColor: "#CCECFF80",
        color: "#0097F0",
      },
    };
  };

  const slotDisc = useDisclosure(false);
  const [selectedSlotDate, setSelectedSlotDate] = useState<any>();
  const [selectedSlots, setSelectedSlots] = useState<any>([]);

  useEffect(() => {
    const changedEvent = combinedEvents?.find(
      (it) => it?.start === selectedSlotDate
    );

    setSelectedSlots(changedEvent ?? []);
  }, [activeSlots?.data?.content, selectedSlotDate]);

  return (
    <Box width={"100%"}>
      {/* show slots available modal */}
      {slotDisc.opened && (
        <SlotAvailabilityModal
          disclosureHost={slotDisc}
          selectedSlots={selectedSlots}
          formik={formik}
        />
      )}

      <LoadingOverlay isLoading={isLoading} />

      <Grid container columnSpacing={2} width={"100%"}>
        <Grid
          item
          md={12}
          xs={12}
          mt={2}
          sx={{
            marginTop: "0px",
          }}
        >
          <Box sx={CALENDER_STYLE}>
            <Calendar
              onSelectEvent={(selectedEvent) => {
                setSelectedSlotDate(selectedEvent?.start);
                slotDisc.open();
              }}
              localizer={localizer}
              events={combinedEvents}
              startAccessor="start"
              endAccessor="end"
              view={"month"}
              eventPropGetter={() => {
                return {
                  style: {
                    border: "1px solid #0097F0",
                    backgroundColor: "#F3F4F6",
                    borderRadius: 6,
                    color: "black",
                    maxHeight: "30px",
                    maxWidth: "70%",
                    ...eventPropGetter(),
                  },
                };
              }}
              style={{
                height: "calc(100vh - 5.3rem)",
                fontFamily: "roboto",
              }}
              components={{
                toolbar: toolBarComponent,
                event: eventWrapper,
              }}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Availability;
